import { Injectable } from '@angular/core';
import { getReportOwnerUsername, getSearchSettings } from '@mode/shared/util-js';
import { HttpClient } from '@angular/common/http';
import { catchError, firstValueFrom, throwError } from 'rxjs';
import { BugsnagService } from '@mode/shared/util-error-handling';
import { SearchSettingsResource } from './search.types';

@Injectable({
  providedIn: 'root',
})
export class SearchFetchService {
  constructor(
    private http: HttpClient,
    private bugsnagService: BugsnagService
  ) {}

  public getSearchSettings() {
    const url = this.resolveSearchSettingsUrl();

    return this.http.get<SearchSettingsResource>(url).pipe(
      catchError((e) => {
        this.bugsnagService.notify(e);
        return throwError(e);
      })
    );
  }

  public async getSearchSettingsPromise(): Promise<SearchSettingsResource['settings']> {
    const data = await firstValueFrom(this.getSearchSettings());

    return data.settings;
  }

  public resolveSearchSettingsUrl(): string {
    const url = getSearchSettings(window.document);
    const owner = getReportOwnerUsername(window.document);
    let result: string = url ?? '';

    if (!url && !owner) {
      throw new Error('Algolia settings URL is undefined');
    }

    if (!url) {
      // In cases when algolia settings url is not available on the
      // DOM like on the new empty report page
      result = `/api/search_settings/${owner}`;
    }

    return result;
  }
}
